import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OfferDuration } from 'shared/models/static-list-data.service';

@Component({
  selector: 'app-offer-duration-offer-lookup',
  templateUrl: './offer-duration-offer-lookup.component.html',
  styleUrls: ['./offer-duration-offer-lookup.component.css']
})
export class OfferDurationLookupComponent implements OnInit {

  @Input() set resetData(isClear) {
    if (isClear) {
      this.offerDurationSelected = [];
    }
  }
  @Input() placeholder = 'Offer Duration';
  @Input() isdisabled = false;
  @Input() filterObjValue = 'offerDuration';
  @Input() isMultipleSelected = false;
  @Input() viewType = '';

  @Output() getOfferDurationObj: EventEmitter<any> = new EventEmitter;


  offerDurationOptionList = [];
  offerDurationSelected = [];

  /**
   * @constructor
   * Represents a OfferDurationLookupComponent.
   */
  constructor() {
  }

  ngOnInit() {
    this.offerDurationOptionList = OfferDuration;
    const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
    this.offerDurationSelected = (preselected && preselected[this.filterObjValue]) ? preselected[this.filterObjValue] : 'Any';
  }

  onOfferDurationChange() {
    this.getOfferDurationObj.emit(this.offerDurationSelected);
  }

  clearOfferDuration() {
    this.offerDurationSelected = [];
    this.getOfferDurationObj.emit([]);
  }

}
